import { NextPage } from 'next';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import Head from 'next/head';

const GrievancePolicy: NextPage = () => {
  return (
    <>
      <Head>
        <title>kliggit - Grievance Policy</title>
      </Head>
      <div>
        <Header />
        <div className="px-5 md:px-[4.875rem] lg:px-[8.8125rem] xl:px-[14.375rem] mb-20">
          <h1 className="mb-4 font-semibold">Grievance Policy</h1>
          <main className="space-y-6">
            <p className="mb-6 font-semibold">Last updated: July 14, 2021</p>
            <p>
              This document sets out our Grievance Policy. For users of the
              kliggit Site, this Grievance Policy is part of your agreement with
              us. In this Grievance Policy, defined terms have the same meanings
              given to them in the KLIGGIT GLOBAL TERMS OF SERVICE AND USE FOR
              ALL USERS (&quot;Site Terms&quot;).
            </p>
            <p>
              kliggit stands behind our Offerings and values all Users’
              experiences on our Site.
            </p>
            <ol className="ml-[4.875rem] mb-[4.5rem] space-y-6 list-decimal list-inside">
              <li>
                <span className="font-bold">Contact:</span> To notify us of a
                complaint about a TalkTime or other Offering, or any experience
                you have had on our Site, please contact us at
                grievance@kliggit.com. We want to hear from you whether or not
                you are a registered User of kliggit, and can use this
                Complaints Policy to alert us to any complaint which you have
                relating to kliggit.{' '}
              </li>
              <li>
                <span className="font-bold">What to include:</span> If you have
                a grievance (or complaint) about kliggit (including any
                complaint about Content appearing on our Site or the conduct of
                a User), please notify us at grievance@kliggit.com. Include your
                name, address, contact details, a description of your complaint
                and, if your complaint is about Content, the URL or screenshot
                of the Content to which it relates. While email is our preferred
                contact, we will also accept written grievances at 903 West
                Sheridan Street, APT. 216, Oklahoma City, OK 73106. This policy
                is intended to cover requests for refunds on purchases.
              </li>
              <li>
                <span className="font-bold">Action we will take:</span> After
                receipt of your grievance or complaint, we will investigate it
                within a reasonable time. If we require more information or
                documents, we will contact you.
                <ul className="ml-[4.875rem] mt-6 space-y-6 list-lower-alpha list-inside">
                  <li>
                    We will in good faith take any actions we consider
                    appropriate: If you have complained about Content on our
                    Site, and we are satisfied the Content is unlawful or
                    otherwise breaches our Site Terms, we will act quickly to
                    remove the Content.
                  </li>
                  <li>
                    Unless applicable law requires otherwise, we need not inform
                    you of the action we take.
                  </li>
                  <li>
                    TalkTime Events:
                    <ul className="ml-[4.875rem] mt-6 space-y-6 list-inside">
                      <li>
                        (i) Once the complaint about an Event is reported, the
                        video is held for review prior to being uploaded.
                      </li>
                      <li>
                        (ii) All funds are held by us until the complaint and
                        refund request is approved or rejected based on our Site
                        Terms.
                      </li>
                      <li>
                        (iii) We will attempt to complete the review within 7-14
                        business days.
                      </li>
                      <li>
                        (iv) If the Content violates our Site Terms, the video
                        will not be uploaded. We reserve the right to withhold
                        payment from any User who violates our policy.
                      </li>
                      <li>
                        (v) If we determine there is no violation of our Site
                        Terms, the video will be uploaded and the Creator will
                        receive full funds.
                      </li>
                    </ul>
                  </li>
                  <li>
                    Refunds
                    <ul className="ml-[4.875rem] mt-6 space-y-6 list-inside">
                      <li>
                        (i) Any refund request must be made within 24 hours
                        following a TalkTime Event (or receipt of purchased
                        Offerings), unless an Additional Term applies.
                      </li>
                      <li>
                        (ii) We will reasonably attempt to process and act on
                        your request within 14 business days. You agree to
                        provide any further information reasonably requested by
                        us.
                      </li>
                      <li>
                        (iii) If your request is based on a violation of our
                        Site Terms, and we approve your request, you may receive
                        a partial or full refund based on the violation.
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>
                <span className="font-bold">
                  Groundless or abusive complaints:
                </span>{' '}
                You agree that you will make no complaint under this Grievance
                Policy which is unfounded or made in bad faith (including to
                harass or bully another User). You agree to be truthful about
                any facts you allege. If we determine you have breached this
                provision, we may suspend or terminate your User account. If we
                do so, you may seek a review of that decision through a written
                request at review@kliggit.com.
              </li>
            </ol>
          </main>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default GrievancePolicy;
